

const parseHtml = (value)=>{
    let tParser = document.createElement('div');
    tParser.innerHTML = value;
    return tParser.textContent 
}

export default parseHtml